import CreateWork from '../views/officialSupport/CreateWork';
import MyWorkList from '../views/officialSupport/MyWorkList';
import MyWork from '../views/officialSupport/MyWork';
import WorkHome from '../views/officialSupport/WorkHome';
import WorkSearch from '../views/officialSupport/WorkSearch';
import WorkTemp from '../views/officialSupport/WorkTemp';
import WorkFaqList from '../views/officialSupport/WorkFaqList';
import WorkFaqDetail from '../views/officialSupport/WorkFaqDetail';
import AccountDelete from '../views/officialSupport/AccountDelete';
import globalConfig from '@utiles/globalConfig';
import { pageType, viewPage } from '@plugins/biPoint/_configOfficialSupport';
export default [
  {
    path: '/',
    name: 'root',
    beforeEnter: (to, from, next) => {
      const gameId =
        globalConfig.getHrefParam('gameId') ||
        globalConfig.getHrefParam('gameID') ||
        globalConfig.getHrefParam('game_id');
      if (gameId) {
        next();
      } else {
        next('/mylist');
      }
    }
  },
  {
    path: '/creatework',
    name: 'creatework',
    meta: {
      index: 3,
      pageName: pageType.orderCreatePage,
      isKeepAlive: false
    },
    component: CreateWork
  },
  {
    path: '/mylist',
    name: 'mylist',
    meta: {
      index: 2,
      pageName: pageType.orderListPage,
      isKeepAlive: false
    },
    component: MyWorkList,
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.orderListPage);
      next();
    }
  },
  {
    path: '/mywork/:workId',
    name: 'mywork',
    meta: {
      index: 4,
      pageName: pageType.orderDetailPage,
      isKeepAlive: false
    },
    component: MyWork,
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.orderDetailPage);
      next();
    }
  },
  {
    path: '/workhome',
    name: 'workhome',
    meta: {
      index: 1,
      pageName: pageType.homePage,
      isKeepAlive: true
    },
    component: WorkHome,
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.homePage);
      next();
    }
  },
  {
    path: '/worksearch',
    name: 'worksearch',
    meta: {
      index: 2,
      pageName: pageType.searchPage,
      isKeepAlive: false
    },
    component: WorkSearch,
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.searchPage);
      next();
    }
  },
  {
    path: '/worktemp',
    name: 'worktemp',
    meta: {
      index: 3,
      pageName: pageType.smartOrderPage,
      isKeepAlive: false
    },
    component: WorkTemp,
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.smartOrderPage);
      next();
    }
  },
  {
    path: '/workfaqlist',
    name: 'workfaqlist',
    meta: {
      index: 3,
      pageName: pageType.faqListPage,
      isKeepAlive: true
    },
    component: WorkFaqList,
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.faqListPage);
      next();
    }
  },
  {
    path: '/workfaqdetail',
    name: 'workfaqdetail',
    meta: {
      index: 4,
      pageName: pageType.faqDetailPage,
      isKeepAlive: false
    },
    component: WorkFaqDetail
  },
  {
    path: '/accountdelete',
    name: 'accountdelete',
    meta: {
      index: 3,
      pageName: pageType.accountDeletePage,
      isKeepAlive: false
    },
    component: AccountDelete,
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.accountDeletePage);
      next();
    }
  }
];
